import { useEffect } from 'react'

const useHideSiteFooter = () =>
  useEffect(() => {
    const $footer: HTMLElement = document.querySelector('#site-footer')
    if ($footer) $footer.style.display = 'none'
    return () => {
      if ($footer) $footer.style.display = 'block'
    }
  }, [])

export default useHideSiteFooter
